import React from "react";
import { Route, Redirect } from "react-router-dom";
import auth from "../services/Auth";

export const ProtectedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!auth.isTokenExpired()) {
          return <Component {...props} />;
        } else {
          auth.logout();
          return (
            <Redirect
              to={{
                pathname: "/",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};
